import React, { Suspense } from "react";
import Header from "../components/Header";
import HeroSection from "../components/HeroSection";

import PortfolioSection from "../components/PortfolioSection";
const PilastroSection = React.lazy(() => import("../components/PilastroSection"));
const PrezziSection = React.lazy(() => import("../components/PrezziSection"));
const ContattoSection = React.lazy(() => import("../components/ContattoSection"));
const Footer = React.lazy(() => import("../components/Footer"));

export default function LandingPage() {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-white overflow-x-hidden">
      <Header />
      <main>
        <HeroSection />
        <PortfolioSection />
        <Suspense fallback={<div className="h-[500px] bg-slate-50 animate-pulse" />}>
          <PilastroSection />
        </Suspense>
        <Suspense fallback={<div className="h-[600px] bg-white animate-pulse" />}>
          <PrezziSection />
        </Suspense>
        <Suspense fallback={<div className="h-[400px] bg-slate-50 animate-pulse" />}>
          <ContattoSection />
        </Suspense>
      </main>
      <Suspense fallback={<div className="h-64 bg-slate-900" />}>
        <Footer />
      </Suspense>
    </div>
  );
}
